var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.25 6C15.25 5.58579 15.5858 5.25 16 5.25H22C22.4142 5.25 22.75 5.58579 22.75 6V12C22.75 12.4142 22.4142 12.75 22 12.75C21.5858 12.75 21.25 12.4142 21.25 12V7.81066L15.5303 13.5303C15.5013 13.5593 15.4727 13.588 15.4445 13.6162C14.9844 14.0771 14.6282 14.4338 14.221 14.6356C13.4516 15.0169 12.5484 15.0169 11.779 14.6356C11.3718 14.4338 11.0156 14.0771 10.5555 13.6162C10.5273 13.588 10.4987 13.5593 10.4697 13.5303C9.88157 12.9422 9.71099 12.7857 9.55498 12.7084C9.20526 12.5351 8.79467 12.5351 8.44496 12.7084C8.28895 12.7857 8.11837 12.9422 7.53028 13.5303L2.53033 18.5303C2.23744 18.8232 1.76256 18.8232 1.46967 18.5303C1.17678 18.2374 1.17678 17.7625 1.46967 17.4696L6.46962 12.4697C6.49865 12.4406 6.52725 12.412 6.55546 12.3837C7.01555 11.9229 7.37172 11.5661 7.77895 11.3643C8.54832 10.9831 9.45162 10.9831 10.221 11.3643C10.6282 11.5661 10.9844 11.9229 11.4445 12.3837C11.4727 12.412 11.5013 12.4406 11.5303 12.4697C12.1184 13.0577 12.289 13.2143 12.445 13.2916C12.7947 13.4649 13.2053 13.4649 13.555 13.2916C13.711 13.2143 13.8816 13.0577 14.4697 12.4697L20.1893 6.75H16C15.5858 6.75 15.25 6.41421 15.25 6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp);
export default __webpack_public_path__ + "static/media/trend-up.33e2ec73119c5c9a72419c680dada19f.svg";
export { ForwardRef as ReactComponent };